import * as React from "react";
import Styles from "./Breadcrumbs.module.css";
export interface Props {
  children: any;
}

const BreadcrumbsItem: React.FC<Props> = props => {
  const { children } = props;
  return <li className={Styles.item}>{children}</li>;
};

export default BreadcrumbsItem;
